import {
  Box,
  CircularProgress,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { useStyles } from '../styles'
import {
  handleCoproprietaire,
  handleLRAR,
  handleRoles,
  handleStatus,
} from '../utils'
import { useNavigate } from 'react-router'
import { useTranslate } from 'react-admin'
import { useState } from 'react'
import { handleContact } from '../../Convocations/utils'

const OpposantsContent = ({ id, data, loadingData }) => {
  const navigate = useNavigate()
  const translate = useTranslate()
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [dataFile, setDataFile] = useState('')

  const getPreviewFile = async (file) => {
    console.log({ file })
    setOpen(true)
    setDataFile(file)
  }
  if (data?.length == 0 && !loadingData) return null

  return (
    <>
      {loadingData ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100px',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer className={classes.spacing}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Statut</TableCell>
                  <TableCell align="left">Copropriétaire</TableCell>
                  <TableCell align="left">Contact</TableCell>
                  <TableCell align="center">LRAR</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {handleStatus(row.status)}
                    </TableCell>
                    <TableCell align="left">
                      {handleCoproprietaire(row)}
                    </TableCell>
                    <TableCell align="left">
                      {handleContact(row.contact, translate)}
                    </TableCell>
                    <TableCell align="center">
                      {handleLRAR(row, id, translate, getPreviewFile)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <PreviewFile
            filePath={dataFile}
            open={open}
            onClose={() => {
              setOpen(false)
            }}
          />
        </>
      )}
    </>
  )
}
const PreviewFile = ({ filePath, open, onClose }) => {
  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      onClose={onClose}
      fullWidth="true"
      maxWidth="md"
      open={open}
    >
      <embed
        src={`${window.location.origin}${filePath}`}
        type="application/pdf"
        width="1000px"
        height="600px"
      />
    </Dialog>
  )
}

export default OpposantsContent
